import 'react-date-picker/dist/DatePicker.css';
import NumberFormat from "react-number-format";
import {doesCurrentTaxYearMatchCurrentYear, getCurrentTaxYear} from "../../../../helpers/utils/Utils";
import {
    calculateAgriculturalValue,
    calculateAppraisedValue,
    calculateAsOfDate,
    calculateAssessedValue,
    calculateCurrentWithExemptionEstimateValue,
    calculateCurrentWoExemptAmountValue,
    calculateLandTotalValue, countDecimals
} from "../../../../helpers/utils/OrderDetailUtils";
import SelectField from '../../../../components/common/form/SelectField';
import {feeListEnabledEnumsRegex, maxYear, minYear} from "../../../../helpers/constants";
import React, {useEffect, useState} from "react";
import DateInputFieldForHeader from "../DateInputFieldForHeader";
import moment from "moment/moment";
import _ from "lodash";
import axiosInstance from "../../../../axiosInstance";

export const isAgExemptionExist = (curAccount: any): boolean => {
    const exemptionList = curAccount?.assessment?.exemptions;
    return Array.isArray(exemptionList) && exemptionList.includes("AG");
};


export const assessmentsAgRowFormatting = (
    setOverrideValue: any,
    curAccount: any,
    editable: boolean,
    certificate: any,
    setCertificate: any,
    name: string,
    setIsSavedResult: any,
    showAccount: number,
    setUpdatedAccountIndexList: any,
) => {
    const fieldValue = curAccount?.assessment?.[name];

    const cleanedValue =
        fieldValue === null || fieldValue === '' || fieldValue === undefined
            ? ''
            : fieldValue;

    const isEditable = editable && isAgExemptionExist(curAccount);
    const placeholder = cleanedValue === '' ? 'N/A' : '...';

    return (
        <NumberFormat
            placeholder={placeholder}
            className={`form-control ${!editable ? "border border-text-0 bg-surface-5 text-surface-3" : ""}`}
            decimalSeparator="."
            isNumericString
            value={cleanedValue}
            prefix={cleanedValue !== '' ? "$" : ""}
            id={`${name}`}
            onChange={(e: any) => {
                if (!isEditable) return;

                const rawValue = e.target.value;
                const parsedValue = rawValue !== ''
                    ? parseFloat(rawValue.replace('$', '').replaceAll(',', ''))
                    : null;

                const updatedAccounts = [...(certificate?.accounts || [])];
                const updatedAccount = { ...updatedAccounts[showAccount] };
                const updatedAssessment = { ...updatedAccount?.assessment };

                updatedAssessment[name] = parsedValue;
                updatedAccount.assessment = updatedAssessment;
                updatedAccount.taxDataSource = "EDITOR";
                updatedAccount.asOfDate = new Date();
                updatedAccounts[showAccount] = updatedAccount;

                setCertificate({
                    ...certificate,
                    accounts: updatedAccounts
                });

                setOverrideValue(true);

                setUpdatedAccountIndexList((prev: any) =>
                    prev.includes(showAccount) ? prev : [...prev, showAccount]
                );

                setIsSavedResult(false);
            }}
            readOnly={!isEditable}
        />
    );
};



export const assessmentsAgOverrideFormatting = (
    certificate: any,
    setCertificate: any,
    showAccount: number,
    name: string,
    setName: any,
    setProductTypeInvisible: any,
    editable: boolean,
    overrideFieldName: string,
    setIsSavedResult: any,
    setRender = null
) => {
    const curAccount = certificate?.accounts[showAccount];
    const assessment = curAccount?.assessment;
    const overrideValue = assessment[overrideFieldName];
    const baseValue = assessment[name];
    const valueToShow = overrideValue === null ? (baseValue === null ? "N/A" : baseValue) : overrideValue;

    const updateAssessmentValue = (newValue: any, override: boolean) => {
        const updatedAccounts = [...certificate.accounts];
        const updatedAccount = {...updatedAccounts[showAccount]};
        const updatedAssessment = {...updatedAccount.assessment};

        updatedAssessment[overrideFieldName] = override ? newValue : null;

        updatedAccount.assessment = updatedAssessment;
        updatedAccount.taxDataSource = 'EDITOR';
        updatedAccount.asOfDate = new Date();
        updatedAccounts[showAccount] = updatedAccount;

        setCertificate({
            ...certificate,
            accounts: updatedAccounts
        });

        if (override) {

            setName(name);
            setProductTypeInvisible(newValue + new Date().getTime());

            if (name === "landTotalValue") {

                calculateAppraisedValue(showAccount, updatedAssessment, setRender, setCertificate);
            } else {
                calculateAssessedValue(showAccount, updatedAssessment, setRender, setCertificate);
            }
        } else {
            if (editable && isAgExemptionExist(updatedAccount) && name === "agriculturalValue") {
                calculateAgriculturalValue(showAccount, updatedAssessment, setRender, setCertificate);
                calculateAssessedValue(showAccount, updatedAssessment, setRender, setCertificate);
            } else if (name === "landTotalValue") {
                calculateLandTotalValue(showAccount, updatedAssessment, setRender, setCertificate);
                calculateAppraisedValue(showAccount, updatedAssessment, setRender, setCertificate);
            }
        }

        setIsSavedResult(false);

    };

    return (
        <div className="assessment_data relative">
            <NumberFormat
                placeholder={(overrideValue === null || overrideValue === undefined) ? "N/A" : "..."}
                className={(overrideValue === null || overrideValue === undefined) ? "form-control place_holder_data" : `form-control ${!editable ? "border border-text-0 bg-surface-5 text-surface-3" : ""}`}
                id={`${name}`}
                decimalScale={overrideValue !== undefined && baseValue !== null && baseValue !== '' ? 2 : undefined}
                decimalSeparator="."
                fixedDecimalScale
                value={valueToShow}
                isNumericString={overrideValue !== null || baseValue !== null || true}
                onChange={(e: any) => {
                    if (!editable || overrideValue === null) return;

                    const cleanedValue = e.target.value !== ''
                        ? parseFloat(e.target.value.replace('$', '').replaceAll(',', ''))
                        : '';

                    updateAssessmentValue(cleanedValue, true);
                }}
                prefix={(overrideValue !== null) ? '$' : (baseValue !== null ? '$' : '')}
                thousandSeparator={true}
                readOnly={!editable || overrideValue === null}
            />

            <div className="assessment_icons absolute right-3 top-3">
                {overrideValue == null ? (
                    <i
                        className={
                            (editable && isAgExemptionExist(curAccount)) || name !== "agriculturalValue"
                                ? "fa fa-pen ml-auto readonly_icon text-highlight-0"
                                : "fa fa-pen ml-auto disableSelection text-highlight-0"
                        }
                        onClick={() => {
                            if ((editable && isAgExemptionExist(curAccount)) || name !== "agriculturalValue") {
                                updateAssessmentValue(baseValue, true);
                            }
                        }}
                    />
                ) : (
                    <i
                        className={
                            (editable && isAgExemptionExist(curAccount)) || name !== "agriculturalValue"
                                ? "fa fa-rotate-right readonly_icon text-highlight-0"
                                : "fa fa-rotate-right disableSelection text-highlight-0"
                        }
                        onClick={() => {
                            updateAssessmentValue(null, false);
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export const exemptionsList = (
    itemMap: any,
    label: any,
    value: any,
    placeholderText: any,
    isMulti: boolean,
    isRequired: boolean,
    curAccount: any,
    setProductTypeInvisible: (value: any) => void,
    setIsSavedResult: (value: boolean) => void,
    showAccount: number,
    setUpdatedAccountIndexList: React.Dispatch<React.SetStateAction<number[]>>
) => {
    if (!curAccount?.assessment) {
        return null;
    }

    const assessment = curAccount.assessment;

    const options: any = Array.isArray(itemMap)
        ? itemMap.map((item: any) => ({
            value: typeof value === 'function' ? value(item) : item[value],
            label: typeof label === 'function' ? label(item) : item[label],
        }))
        : [];

    const handleChange = (selected: any) => {

        assessment.exemptions = Array.isArray(selected)
            ? selected.map((opt: any) => opt?.value)
            : [selected?.value];
        setIsSavedResult(false);
        setUpdatedAccountIndexList((prevList) => {
            if (!prevList.includes(showAccount)) {
                return [...prevList, showAccount];
            }
            return prevList;
        });

        setProductTypeInvisible(Date.now());
    };

    const selectedOptions: any = Array.isArray(assessment?.exemptions)
        ? assessment.exemptions.map((val: any) => {
            const match = options.find((opt: any) => opt.value === val);
            return match || {label: String(val), value: val}; // Ensure label is a string
        })
        : [];

    return (
        <SelectField
            placeholder={placeholderText}
            value={selectedOptions}
            options={options}
            onChange={handleChange}
            hideLabel
            label=""
            isMulti={isMulti}
            required={isRequired}
            isDisabled={!options || !options.length}
        />
    );
};

export const assessmentOverrideFormatting = (
    curAccount: any,
    name: any,
    setName: any,
    setProductTypeInvisible: any,
    editable: any,
    overrideFieldName: any,
    setIsSavedResult: any,
    setRender: any,
    showAccount: any,
    setUpdatedAccountIndexList: any,  // Add setter for immutability
    setCertificate: any,
    certificate: any
) => {

    return (
        <>
            <div className="assessment_data relative">
                {curAccount?.assessment ? (
                    <NumberFormat
                        placeholder={
                            curAccount.assessment?.[overrideFieldName] == null
                                ? "N/A"
                                : "..."
                        }
                        className={
                            curAccount.assessment?.[overrideFieldName] == null
                                ? "form-control place_holder_data"
                                : "form-control"
                        }
                        id={`${name}`}
                        decimalScale={
                            curAccount?.assessment[overrideFieldName] != null ||
                            curAccount?.assessment[name] != null
                                ? (name !== "woExemptionAmount" && name !== "withExemptionEstimate" ? 0 : 2)
                                : undefined
                        }
                        decimalSeparator="."
                        fixedDecimalScale
                        isNumericString={
                            curAccount.assessment?.[overrideFieldName] != null ||
                            curAccount.assessment?.[name] != null
                        }
                        value={
                            curAccount.assessment?.[overrideFieldName] == null
                                ? curAccount.assessment?.[name] == null
                                    ? "N/A"
                                    : curAccount.assessment?.[name]
                                : curAccount.assessment?.[overrideFieldName]
                        }
                        onChange={(e: any) => {
                            const newValue =
                                e.target.value !== ""
                                    ? parseFloat(
                                        e.target.value.replace("$", "").replaceAll(",", "")
                                    )
                                    : e.target.value;

                            // Deep clone for immutability
                            let updatedCertificate = structuredClone(certificate);
                            const updatedAccount = updatedCertificate.accounts[showAccount];

                            updatedAccount.assessment = {
                                ...updatedAccount.assessment,
                                [overrideFieldName]: newValue,
                            };

                            updatedAccount.taxDataSource = "EDITOR";
                            updatedAccount.asOfDate = new Date();
                            setName(name);
                            setProductTypeInvisible(e.target.value + new Date().getTime());

                            setCertificate(updatedCertificate);

                            // Conditional calculations
                            const assessment = updatedAccount.assessment;
                            if (name === "appraisedValue" && assessment?.taxYear >= getCurrentTaxYear()) {
                                calculateCurrentWoExemptAmountValue(
                                    updatedCertificate,
                                    showAccount,
                                    assessment,
                                    setRender,
                                    setCertificate
                                );
                            }

                            if (name === "assessedValue" && assessment?.taxYear >= getCurrentTaxYear()) {
                                calculateCurrentWithExemptionEstimateValue(
                                    updatedCertificate,
                                    showAccount,
                                    assessment,
                                    setRender,
                                    setCertificate
                                );
                            }

                            setIsSavedResult(false);

                            setUpdatedAccountIndexList((prev: number[]) =>
                                prev.includes(showAccount) ? prev : [...prev, showAccount]
                            );
                        }}
                        prefix={
                            curAccount.assessment?.[overrideFieldName] != null ||
                            curAccount.assessment?.[name] != null
                                ? "$"
                                : ""
                        }
                        thousandSeparator={true}
                        readOnly={
                            !editable || curAccount.assessment?.[overrideFieldName] === null
                        }
                    />
                ) : null}
                <div className="assessment_icons absolute top-2 right-0">
                    {curAccount?.assessment ? (
                        curAccount.assessment?.[overrideFieldName] == null ? (
                            <i
                                className="fa fa-pen ml-auto mr-2 readonly_icon text-highlight-0"
                                onClick={() => {
                                    if (editable === true) {
                                        const updatedCertificate = structuredClone(certificate);
                                        const updatedAccount = updatedCertificate.accounts[showAccount];

                                        updatedAccount.assessment = {
                                            ...updatedAccount.assessment,
                                            [overrideFieldName]:
                                                updatedAccount.assessment?.[name],
                                        };
                                        setCertificate(updatedCertificate);
                                    }
                                }}
                            />
                        ) : (
                            <i
                                className="fa fa-rotate-right mr-2 readonly_icon text-highlight-0"
                                onClick={() => {
                                    if (editable === true) {
                                        let updatedCertificate = structuredClone(certificate);
                                        const updatedAccount = updatedCertificate.accounts[showAccount];

                                        updatedAccount.assessment = {
                                            ...updatedAccount.assessment,
                                            [overrideFieldName]: null,
                                        };

                                        const assessment = updatedAccount.assessment;
                                        if (name === "appraisedValue") {
                                             calculateAppraisedValue(showAccount, assessment, setRender, setCertificate).then(() => {
                                                if (assessment?.taxYear >= getCurrentTaxYear()) {
                                                    calculateCurrentWoExemptAmountValue(
                                                        updatedCertificate,
                                                        showAccount,
                                                        assessment,
                                                        setRender,
                                                        setCertificate
                                                    );
                                                }
                                            });
                                        } else {
                                            calculateAssessedValue(showAccount, assessment, setRender, setCertificate).then(() => {
                                                if (assessment?.taxYear >= getCurrentTaxYear()) {
                                                    calculateCurrentWithExemptionEstimateValue(
                                                        updatedCertificate,
                                                        showAccount,
                                                        assessment,
                                                        setRender,
                                                        setCertificate
                                                    );
                                                }
                                            });
                                        }
                                    }
                                }}
                            />
                        )
                    ) : null}
                </div>
            </div>
        </>
    );
};

export function getAssessmentList(certificate: any, i: any) {
    let account = certificate.accounts[i];
    let currentAssessment = account.assessment;

    if (!currentAssessment) {
        return dummyAssessment();
    }
    return currentAssessment;
}
export async function recalculateAssessment(
    showAccount: number,
    certificate: any,
    setRender: any,
    setCertificate: any
): Promise<void> {

    try {
        const account = certificate.accounts[showAccount];
        if (!account || !account.assessment) return;

        const obj = { ...account.assessment };

        const [
            assessedValueRes,
            appraisedValueRes,
            agriculturalValueRes,
            landTotalValueRes,
        ] = await Promise.all([
            axiosInstance.post(`/editor/auto-calculated-values/national/assessedValue`, obj),
            axiosInstance.post(`/editor/auto-calculated-values/appraisedValue`, obj),
            axiosInstance.post(`/editor/auto-calculated-values/agriculturalValue`, obj),
            axiosInstance.post(`/editor/auto-calculated-values/landTotal`, obj),
        ]);

        setRender(Date.now());

        setCertificate((prev: any) => {
            const updatedAccounts = [...prev.accounts];
            const updatedAccount = { ...updatedAccounts[showAccount] };
            const updatedAssessment = {
                ...updatedAccount.assessment,
                assessedValue: assessedValueRes.data,
                appraisedValue: appraisedValueRes.data,
                agriculturalValue: agriculturalValueRes.data,
                landTotalValue: landTotalValueRes.data,
            };

            updatedAccount.assessment = updatedAssessment;
            updatedAccounts[showAccount] = updatedAccount;

            return {
                ...prev,
                accounts: updatedAccounts,
            };
        });
    } catch (error) {
        console.error('Error in recalculateAssessment:', error);
    }
}

export function dummyAssessment() {
    let currentTaxYear = getCurrentTaxYear();
    let desiredYear = doesCurrentTaxYearMatchCurrentYear() ? currentTaxYear + 1 : currentTaxYear - 1;

    return {
        "taxYear": desiredYear > currentTaxYear ? currentTaxYear : desiredYear,
        "improvementMarketValue": null,
        "landMarketValue": null,
        "agMarketValue": null,
        "overrideAppraisedValue": null,
        "overrideAssessedValue": null,
        "agTimberValue": null,
        "agLossValue": null,
        "homesteadCapValue": 0,
        "exemptions": [],
        "assessedValue": null,
        "agriculturalValue": null,
        "landTotalValue": null,
        "overrideAgValue": null,
        "appraisedValue": null,
        "certified": false,
        "overrideLandTotalValue": null,
        "woExemptionAmount": null,
        "overrideWoExemptionAmount": null,
    };
}


export const nationalJurisdictionYearFields = (row: any, setJurisdictionId: any, p: any, curAccount: any, setAccounts: any, accounts: any, setUpdateTotalTaxValue: any, setTaxYear: any, setIsAddNewSummaryRow: any, name: any, disabled: any, setIsSavedResult: any, editable: any, setAutoCalculate: any) => {
    let style = 'border-0 p-3 pr-0 text-center w-full';
    style = style + (row['placeHolder'] && row['name'] ? ' place_holder' : '');
    style = style + (!row['name'] ? ' text-surface-3 ' : '');
    return (
        <>
            <input
                className={style}
                placeholder={!row[name] ? "N/A" : 'Year...'}
                type='number'
                name='taxYear'
                min={minYear}
                max={maxYear}
                value={row[name]}
                onChange={(e) => {
                    row["placeHolder"] = false;
                    setJurisdictionId(p);
                    setIsSavedResult(false);
                    validateYear(e, p, name, curAccount.jurisdictionList, setUpdateTotalTaxValue, setTaxYear, setJurisdictionId, setIsAddNewSummaryRow);
                    calculateAsOfDate(row);
                    setAutoCalculate(true);
                    setAccounts([...accounts]);
                    setIsAddNewSummaryRow(true)
                }}
                readOnly={disabled || !editable}
            />
        </>
    )
}

const validateYear = (e: any, index: any, name: any, listType: any, setUpdateTotalTaxValue: any, setTaxYear: any, setJurisdictionId: any, setIsAddNewSummaryRow: any) => {
    if (e.target.value.length > 4) {
        listType[index][name] = e.target.value.slice(0, 4);
        e.target.value = listType[index][name];
    }

    if (e.target.value.length === 4) {
        if (!(e.target.value > minYear && e.target.value <= maxYear)) {
            listType[index][name] = e.target.value.slice(0, 0);
            e.target.value = listType[index][name];
        } else {
            listType[index][name] = e.target.value;
            if (name === 'baseTax') {
                let result = listType[index]['tax_rate_List'].filter((value1: any) => value1.year.toString() === e.target.value);
                if (result.length > 0 && listType[index]['nonCollecting'] === false) {
                    listType[index]['baseTax'] = result[0]['rate'];
                } else {
                    listType[index]['baseTax'] = '';
                }
                setUpdateTotalTaxValue(true);
            }
            e.target.value = listType[index][name];
        }
    } else {
        listType[index][name] = e.target.value;
        e.target.value = listType[index][name];
    }

    if (name === 'baseTax' && e.target.value.length === 4) {
        setTaxYear(e.target.value);
        setJurisdictionId(index)
        setIsAddNewSummaryRow(true);
    }
}

export const NationalJurisdictionHeader = (
    certificate: any,
    setCertificate: (val: any) => void,
    setShowJurisdictionPickerModal: (val: boolean) => void,
    editable: boolean,
    setIsSavedResult: (val: boolean) => void,
    setRender: (val: number) => void,
    showAccount: any,
    updatedAccountIndexList: number[],
    setUpdatedAccountIndexList: (val: number[]) => void
) => {

    const handleIfPaidByDateChange = (fieldName: 'nextPeriodDueDate' | 'nextNextPeriodDueDate') =>
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const newDate = moment(event.target.value.toUpperCase());

            const updatedAccounts = [...certificate.accounts];
            const updatedAccount = {
                ...updatedAccounts[showAccount],
                [fieldName]: newDate,
            };

            updatedAccounts[showAccount] = updatedAccount;

            setCertificate({
                ...certificate,
                accounts: updatedAccounts
            });

            setRender(Date.now());

            if (!updatedAccountIndexList.includes(showAccount)) {
                setUpdatedAccountIndexList([...updatedAccountIndexList, showAccount]);
            }

            setIsSavedResult(false);

        };

    const curAccount = certificate?.accounts?.[showAccount];


    return (
        <thead className={"header_align"}>
        <tr>
            <th scope="col" className=" bg-highlight-3 text-text-0">
                <i className="fa fa-plus-circle onHover"
                   onClick={() => editable && setShowJurisdictionPickerModal(true)}
                   title="Add Jurisdiction"
                />
            </th>
            <th className=" bg-highlight-3 text-text-0"><a className="grid-color toggle-data">Jurisdiction*</a></th>
            <th className=" bg-highlight-3 text-text-0"><a className="grid-color toggle-data">Tax Year</a></th>
            <th className=" bg-highlight-3 text-text-0"><a className="grid-color toggle-data">Bill Type</a></th>
            <th className=" bg-highlight-3 text-text-0"><a className="grid-color toggle-data">Due Date</a></th>
            <th className=" bg-highlight-3 text-text-0"><a className="grid-color toggle-data">Base Tax</a></th>
            <th className=" bg-highlight-3 text-text-0"><a className="grid-color toggle-data">Base Due</a></th>
            <th className=" bg-highlight-3 text-text-0"><a className="grid-color toggle-data">Status</a></th>
            <th className=" bg-highlight-3 text-text-0"><a className="grid-color toggle-data">Paid Date</a></th>
            <th className=" bg-highlight-3 text-text-0">
                <div className="grid-color toggle-data w-[140px]">
                    If Paid By
                    <DateInputFieldForHeader
                        date={curAccount?.nextPeriodDueDate ?? formatDateToMMDDYYYY(moment().endOf('month'))}
                        handleDateChange={handleIfPaidByDateChange('nextPeriodDueDate')}
                        editable={editable}
                    />
                </div>
            </th>
            <th className=" bg-highlight-3 text-text-0">
                <div className="grid-color toggle-data header-date-picker w-[140px]">
                    If Paid By
                    <DateInputFieldForHeader
                        date={curAccount?.nextNextPeriodDueDate ?? formatDateToMMDDYYYY(moment().add(1, 'months').endOf('month'))}
                        handleDateChange={handleIfPaidByDateChange('nextNextPeriodDueDate')}
                        editable={editable}
                    />
                </div>
            </th>
        </tr>
        </thead>
    );
};


const formatDateToMMDDYYYY = (dateString: any) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${month}/${day}/${year}`;
};
export const nationalSelectDropdownField = (
    row: any,
    name: string,
    disabled: boolean,
    setIsSavedResult: (val: boolean) => void,
    setCertificate: any,
    Enums: any[],
    editable: boolean,
    showAccount: number,
    setUpdatedAccountIndexList: any,
    setAutoCalculate: (val: boolean) => void
) => {
    return (
        <select
            className="form-control"
            name="platStatus"
            value={row[name] || ""}
            disabled={disabled || !editable}
            onChange={(e) => {
                const newValue = e.target.value;

                setCertificate((prev: any) => {
                    const updatedAccounts = [...prev.accounts];
                    const currentAccount = updatedAccounts[showAccount]; // no cloning

                    // mutate row directly
                    row[name] = newValue;
                    currentAccount.taxDataSource = 'EDITOR';

                    // special case for type
                    if (name === 'type' && !feeListEnabledEnumsRegex.test(newValue)) {
                        row['periodStart'] = '';
                        row['periodEnd'] = '';
                        row['frequency'] = 'ONE_TIME';
                    }

                    // update summaryList if name === levyPeriod
                    if (name === 'levyPeriod') {
                        const summary = currentAccount.summaryList.find((s: any) => s.jurisdictionId === row.jurisdictionId);
                        if (summary) {
                            summary.levyPeriod = newValue;
                        }
                    }

                    // force re-render
                    return {
                        ...prev,
                        accounts: [...updatedAccounts], // shallow clone triggers React update
                    };
                });

                setIsSavedResult(false);
                setUpdatedAccountIndexList((prev: number[]) =>
                    prev.includes(showAccount) ? prev : [...prev, showAccount]
                );

                if (name === 'levyPeriod') {
                    setAutoCalculate(true);
                }
            }}
            required
        >
            <option value="">
                {name === 'type' ? 'Select Type' : 'Select Frequency'}
            </option>
            {Enums?.map((curEnum: any) => (
                <option key={curEnum.constant} value={curEnum.constant}>
                    {curEnum.value}
                </option>
            ))}
        </select>
    );
};


export function updateSummaryRowInfo(summaryList: any[], sumList: any[], index: number): any[] {
    if (summaryList[index] === undefined) return summaryList;

    const updatedRow = { ...summaryList[index] };

    updatedRow['levyPeriod'] = sumList[0]?.levyPeriod;

    const reduceSum = (key: string) => {
        return sumList.reduce((prev: any, cur: any) => {
            const val = cur[key];
            if (val !== '' && val !== null && prev !== null) return prev + parseFloat(val);
            if (val === '' || val === null || prev === null) return null;
            return prev;
        }, 0);
    };

    updatedRow['baseTax'] = reduceSum('baseTax');
    updatedRow['baseDue'] = reduceSum('baseDue');
    updatedRow['nextPeriodDue'] = reduceSum('nextPeriodDue');
    updatedRow['nextNextPeriodDue'] = reduceSum('nextNextPeriodDue');

    const asOfDateArray: number[] = sumList
        .filter((cur: any) => cur['asOfDate'] !== null && cur['asOfDate'] !== '')
        .map((cur: any) => moment(cur['asOfDate'], 'YYYY-MM-DD').valueOf());

    updatedRow['asOfDate'] = asOfDateArray.length === 0 ? null : new Date(Math.min(...asOfDateArray));

    // return new updated list
    const updatedList = [...summaryList];
    updatedList[index] = updatedRow;

    return updatedList;
}

const billTypeOrder = [
    'ANNUAL',
    'FIRST_HALF',
    'FIRST_QUARTER',
    'SUMMER',
    'SECOND_QUARTER',
    'SECOND_HALF',
    'THIRD_QUARTER',
    'WINTER',
    'FOURTH_QUARTER',
    'FISCAL_YEAR',
    'CALENDAR_YEAR'
];

export function sortByYearAndLevyPeriod(jurisdictionList: any) {
    return _.orderBy(
        jurisdictionList,
        [
            'taxYear',  // First sort by Year (DESC)
            (item) => billTypeOrder.indexOf(item.levyPeriod)
        ],
        ['desc', 'asc']
    );
}


export const summaryTheadNational = (curAccount: any) => {
    return (
        <>
            <thead>
            <tr>
                <th scope="col" className=" bg-highlight-3 text-text-0">Collector
                </th>
                <th scope="col" className=" bg-highlight-3 text-text-0">Account Number
                </th>
                <th scope="col" className=" bg-highlight-3 text-text-0">Tax Year</th>
                <th scope="col" className=" bg-highlight-3 text-text-0">Base Tax
                </th>
                <th scope="col" className=" bg-highlight-3 text-text-0">Base Due
                </th>
                <th scope="col" className=" bg-highlight-3 text-text-0">If Paid By
                    {' ' + formatDateToMMDDYYYY(curAccount && curAccount.nextPeriodDueDate ?
                        curAccount.nextPeriodDueDate :
                        moment().endOf('month'))}</th>
                <th scope="col" className=" bg-highlight-3 text-text-0">If Paid By
                    {' ' + formatDateToMMDDYYYY(curAccount && curAccount.nextNextPeriodDueDate ?
                        curAccount.nextNextPeriodDueDate :
                        moment().add(1, 'months').endOf('month'))}</th>

                <th scope="col" className=" bg-highlight-3 text-text-0">As of Date
                </th>
            </tr>


            </thead>
        </>
    )
}

export function autoNationalCalculateSummaryRow(
    certificate: any,
    setCertificate: React.Dispatch<React.SetStateAction<any>>,
    showAccount: number
) {
    const clonedCertificate = structuredClone(certificate);
    let account = clonedCertificate.accounts[showAccount];
    const { summaryList, jurisdictionList } = account;

    let newSummaryList = [...summaryList]; // start with a copy

    for (let i = 0; i < newSummaryList.length; i++) {
        const matchingJurisdictions = jurisdictionList.filter(
            (jur: any) =>
                jur.collectorName === newSummaryList[i].collector &&
                parseInt(jur.taxYear) === parseInt(newSummaryList[i].taxYear)
        );

        if (matchingJurisdictions.length > 0) {
            newSummaryList = updateSummaryRowInfo(newSummaryList, matchingJurisdictions, i);
        }
    }
    // Update the account with the fully updated list
    account.summaryList = newSummaryList;

    // Update total row if needed
    account = updateSummaryTotalRowCalculation(account, newSummaryList);

    clonedCertificate.accounts[showAccount] = account;
    setCertificate(clonedCertificate);
}



export function updateSummaryTotalRowCalculation(
    currentAccount: any,
    summaryList: any[]
): any {
    if (!summaryList) return currentAccount;

    const parseValue = (val: any): number | null => {
        if (val === '' || val === null || val === undefined) return null;
        const parsed = parseFloat(val.toString().replace(',', ''));
        return isNaN(parsed) ? null : parsed;
    };

    const baseTaxTotal = summaryList.reduce((prev, curr) => {
        const val = parseValue(curr.baseTax);
        return prev !== null && val !== null ? prev + val : null;
    }, 0 as number | null);

    const baseDueTotal = summaryList.reduce((prev, curr) => {
        const val = parseValue(curr.baseDue);
        return prev !== null && val !== null ? prev + val : null;
    }, 0 as number | null);

    const currentMonthTotal = summaryList.reduce((prev, curr) => {
        const val = parseValue(curr.nextPeriodDue);
        return prev !== null && val !== null ? prev + val : null;
    }, 0 as number | null);

    const nextMonthTotal = summaryList.reduce((prev, curr) => {
        const val = parseValue(curr.nextNextPeriodDue);
        return prev !== null && val !== null ? prev + val : null;
    }, 0 as number | null);

    return {
        ...currentAccount,
        baseTaxTotal,
        baseDueTotal,
        currentMonthTotal,
        nextMonthTotal,
    };
}



export function updateNationalSummarySectionRow(
    certificate: any,
    showAccount: number,
    jurisdictionId: any,
    taxYear: any,
    setCertificate: React.Dispatch<React.SetStateAction<any>>
) {
    const clonedCertificate = structuredClone(certificate); // deep clone
    const account = clonedCertificate.accounts[showAccount];
    const jurisdiction = account?.jurisdictionList?.[jurisdictionId];

    if (!jurisdiction) {
        console.warn("Invalid jurisdictionId:", jurisdictionId);
        return certificate;
    }

    const yearToUse = taxYear || jurisdiction.taxYear;
    const levyPeriod = jurisdiction.levyPeriod;

    if (account.summaryList.length === 1 && account.summaryList[0].taxYear === '') {
        account.summaryList[0] = {
            ...account.summaryList[0],
            taxYear: yearToUse,
            levyPeriod,
            collector: jurisdiction.collectorName,
            collectorAccountNumber: jurisdiction.collectorAccountNumber,
            asOfDate: jurisdiction.asOfDate,
            baseTax: jurisdiction.baseTax,
            baseDue: jurisdiction.baseDue,
            nextPeriodDue: jurisdiction.nextPeriodDue,
            nextNextPeriodDue: jurisdiction.nextNextPeriodDue,
        };
    } else {
        const alreadyExists = account.summaryList.some(
            (v: any) =>
                v.collector === jurisdiction.collectorName &&
                parseInt(v.taxYear) === parseInt(yearToUse) &&
                v.levyPeriod === levyPeriod
        );

        if (!alreadyExists) {
            account.summaryList.push({
                collector: jurisdiction.collectorName,
                collectorAccountNumber: jurisdiction.collectorAccountNumber,
                taxYear: yearToUse,
                levyPeriod,
                baseTax: jurisdiction.baseTax,
                baseDue: jurisdiction.baseDue,
                nextPeriodDue: jurisdiction.nextPeriodDue,
                nextNextPeriodDue: jurisdiction.nextNextPeriodDue,
                asOfDate: jurisdiction.asOfDate,
            });
        }
    }

    // Cleanup: remove any summary rows not matching any jurisdiction
    account.summaryList = account.summaryList.filter((summary: any) => {
        return account.jurisdictionList.some(
            (jur: any) =>
                jur.collectorName === summary.collector &&
                parseInt(jur.taxYear) === parseInt(summary.taxYear) &&
                jur.levyPeriod === summary.levyPeriod
        );
    });

    clonedCertificate.accounts[showAccount] = account;
    setCertificate(clonedCertificate);
    return clonedCertificate;
}


export const jurisdictionRowFormatting = (row: any, setAccounts: any, setJurisdictionId: any, p: any, setAutoCalculate: any, accounts: any, index: any, name: any, editable: any, setIsSavedResult: any, curAccount: any, setUpdateTotalTaxValue: any = null, setIsAddNewSummaryRow: any = null, setTaxYear: any = null) => {

    const isFalsyValue = row[name] === null || row[name] === undefined || row[name] === '';
    setAutoCalculate(false);
    return (
        <>
            <NumberFormat
                placeholder={((isFalsyValue) ? "N/A" : '...')}
                className={row['placeHolder'] === false ? (isFalsyValue ? "border-0 form-control text-center" : "border-0 form-control text-center") : (isFalsyValue ? "border-2 border-surface-8  form-control text-center" : "border-2 border-surface-8 form-control text-center")}
                decimalSeparator="."
                fixedDecimalScale
                min="0"
                prefix={!isFalsyValue ? "$" : ''}
                isNumericString={(row[name])}
                value={
                    (isFalsyValue ? "N/A" :
                        (countDecimals(row[name]) === 2 ? row[name] : parseFloat(row[name]).toFixed(2)))
                }
                thousandSeparator={true}
                onChange={(e: any) => {
                    setJurisdictionId(p);
                    row[name] = e.target.value.replace('$', '').replaceAll(',', '');
                    if (row["placeHolder"] === true) {
                        setTaxYear(row["bill_year"]);
                        setIsAddNewSummaryRow(true);
                    }
                    row["placeHolder"] = false;
                    setIsSavedResult(false);
                    if (setUpdateTotalTaxValue !== null) {
                        setUpdateTotalTaxValue(true);
                    }
                    calculateAsOfDate(row);
                    setAutoCalculate(true);
                }}

                disabled={row['jurisdictionName'] === '' || row['collectorName'] === '' || row['jurisdictionName'] === null || row['collectorName'] === null || !editable}
            />

        </>
    )
}


